import { Form } from "@king-design/vue";

export function setupForm() {
  const RE_RELEASE_NAME = /^[a-z]([-a-z0-9]*[a-z0-9])?$/;
  Form.addMethod("validateReleaseName", value => {
    if (RE_RELEASE_NAME.test(value)) {
      return true;
    }
    return "只包含小写字母、数字及分隔符“-”，且必须以小写字母开头，数字或小写字母结尾";
  });

  const RE_NAMESPACE_NAME = /^[a-z0-9]([-a-z0-9]*[a-z0-9])?$/;
  Form.addMethod("validateNamespaceName", value => {
    if (RE_NAMESPACE_NAME.test(value)) {
      return true;
    }
    return "只包含小写字母、数字及分隔符“-”，且必须以字母或数字开头和结尾";
  });
}
